import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login_page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login_image" }, null, -1)
const _hoisted_3 = { class: "login_form" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("header", { class: "p-mb-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/assets/layout/images/logo.png",
    class: "topbar-logo"
  })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-3 p-text-left" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/layout/images/login/icon-login.svg" })
], -1)
const _hoisted_7 = { class: "p-col-9 p-text-left" }
const _hoisted_8 = { class: "welcome-text" }
const _hoisted_9 = { class: "guest-sign-in" }
const _hoisted_10 = {
  key: 1,
  class: "p-grid"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-3 p-text-left" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/layout/images/login/icon-login.svg" })
], -1)
const _hoisted_12 = { class: "p-col-9 p-text-left" }
const _hoisted_13 = { class: "welcome-text" }
const _hoisted_14 = { class: "guest-sign-in" }
const _hoisted_15 = { class: "p-d-flex p-jc-center p-col-12 p-my-5" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Vai alla pagina di login ")
const _hoisted_17 = { class: "p-d-flex p-jc-center p-my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (!_ctx.accomplished)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("h2", _hoisted_8, null, 512), [
                [_directive_t, 'new_pwd.title']
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [
                [_directive_t, 'new_pwd.subtitle']
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.accomplished)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("h2", _hoisted_13, null, 512), [
                [_directive_t, 'new_pwd.title_accomplish']
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_14, null, 512), [
                [_directive_t, 'new_pwd.subtitle_accomplish']
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.loginRoute }
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.accomplished)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
            class: "form mb-3",
            style: {"width":"95%"}
          }, [
            _createVNode(_component_FloatLabel, {
              label: "Password",
              class: "p-fluid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  required: "",
                  autofocus: "",
                  id: "pwd",
                  type: "password",
                  modelValue: _ctx.newPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.newPassword = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_FloatLabel, {
              label: "Conferma Password",
              class: "p-fluid p-mt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  required: "",
                  id: "confirmPwd",
                  type: "password",
                  modelValue: _ctx.confirmPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmPassword = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Button, {
                disabled: _ctx.isLoading,
                type: "submit",
                label: "Imposta password",
                icon: "pi pi-envelope"
              }, null, 8, ["disabled"])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}